module.exports = __webpack_public_path__ + "img/3.8bee5de6.jpg";